
import { defineComponent, ref, computed, watch, reactive, toRefs } from "vue";
import ValidationTextField from "@/components/atomics/ValidationTextField.vue";

export default defineComponent({
  name: "CustomDatepicker",
  components: {
    ValidationTextField,
  },
  props: {
    value: { type: Date },
    isBlack: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    isOverlay: { type: Boolean, default: false },
  },
  emits: ["update:value", "onOpen"],
  setup(props, { emit }) {
    const state = reactive({
      isActive: false,
      popupPosition: {},
    });
    const dateValue = computed({
      get(): Date | undefined {
        return props.value;
      },

      set(value: Date | undefined) {
        emit("update:value", value);
      },
    });

    const datepicker = ref<InstanceType<typeof ValidationTextField>>();

    const focusDatePicker = () => {
      state.isActive = true;
      if (props.isOverlay) {
        state.popupPosition = false;
      } else {
        state.popupPosition = {
          top: "calc(100% + 5px)",
          left: "0",
          transform: "none",
        };
      }
    };

    const focusoutDatePicker = () => {
      state.isActive = false;
    };

    const openDatePicker = () => {
      emit("onOpen")
    }

    return {
      ...toRefs(state),
      dateValue,
      datepicker,
      focusDatePicker,
      focusoutDatePicker,
      openDatePicker,
    };
  },
});
